const categories = [
  { code: 'fandb', value: 'F&B' },
  { code: 'electronics', value: 'Electronics' },
  { code: 'grocery', value: 'Grocery' },
  { code: 'bpc', value: 'BPC' },
  { code: 'fashion', value: 'Fashion' },
  { code: 'appliances', value: 'Appliances' },
  { code: 'handd', value: 'Home & Kitchen' },
  { code: 'handk', value: 'Home & Kitchen' },
  { code: 'handw', value: 'Health & Wellness' }
];

export const useCategoryMasterList = async () => {
  await updateCategoryMaster();
  return categories.map((k) => ({
    code: k.code,
    value: k.value
  }));  
}

export const useCategoryMaster = (key: String) => {
  let value = categories.find((k) => k.code === key?.toLowerCase())?.value;
  return value ? value : "";
};

export const updateCategoryMaster = async () => {
  let values = []

  for (let i = 0; i < categories.length; i++) {
    values.push(categories[i].value.toLowerCase());
  }

  const cmsBannerQuery = {
    partner_id: 'mall4all',
    parent_ids: "S102",
  };

  const { data: cmsBanners } = await useAPIHandler("get", "/cms/banners", {
    query: cmsBannerQuery,
  });

  for (let i = 0; i < cmsBanners.length; i++) {
    if (cmsBanners[i].dynamicSlot && !values.includes(cmsBanners[i].meta.title.toLowerCase())) {
      categories.push({ code: 'fclp', value: cmsBanners[i].meta.title });
    }
  }
}
